import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const MovementYearOnYearVerticalPage = lazy(() => import('./MovementYearOnYearVerticalPage'));
const path = 'reports/movement-yoy-vertical';
const MovementYearOnYearRoute: FuseRouteItemType = {
	path: path,
	element: <MovementYearOnYearVerticalPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Year on Year Movement Vertical',
					helpName: 'Vertical Movement Year on Year',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default MovementYearOnYearRoute;
